const TodosPageLoggedOutView = () => {
  return (
    <p
      style={{
        margin: "1rem",
        display: "flex",
        justifyContent: "center",
      }}
    >
      Please login to see your Todos
    </p>
  );
};

export default TodosPageLoggedOutView;
